import React, { useEffect, useState } from 'react';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import { useNavigate, useParams } from 'react-router-dom';
import instance from '../../service/axiosInstane';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import Dailog from '../../components/Dailog/Dailog';
import { successMessage } from '../../config/keyword';

type AddRolesProps = {
  role: string;
  id: string;
};
type RoleResponce = {
  role: string;
  organization: string;
  organizationId: string;
  id: string;
};

const RolesDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const { id } = useParams();
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isUserEdit, setIsRoleEdit] = useState(false);

  //set property role
  const [roleState, setState] = useState<AddRolesProps>({
    role: '',
    id: '',
  });

  const [responseRole, setResponseRole] = useState<AddRolesProps>({
    role: '',
    id: '',
  });

  //get request Role data to set
  const { role } = roleState;
  useEffect(() => {
    const breadcrumb = [
      { path: '/roles', name: 'Role' },
      { path: `/roleDetails/${id}`, name: 'Role Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getOrgRoleData();
  }, []);
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateOrgRole();
    }
  }, [formError]);

  const handleEdit = () => {
    setIsRoleEdit(!isUserEdit);
  };

  const gotResponse = (data: RoleResponce) => {
    setState(data);
    setResponseRole(data);
    handleEdit;
    dispatch(updateIsLoading(false));
  };
  const handleUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };
  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setState({ ...roleState, [event.target.name]: event.target.value });
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `Rolename is required`,
      });
    }
  };
  //Role Validation
  const validation = () => {
    const error: any = {};
    if (!role) {
      error.role = errorMessage.emptyOrgRole;
    } else if ((role.length > 0 && role.length < 2) || role.length > 128) {
      error.role = errorMessage.orgRoleNameLength;
    }
    return error;
  };

  //when we click cancel button
  const handleUpdateCancel = () => {
    getOrgRoleData();
    setIsRoleEdit(false);
    setIsSubmit(false);
    setFormError({});
  };

  //update Org role
  const updateOrgRole = () => {
    const obj = { name: role };
    instance
      .put(`/organizations/${userInfo.organizationId}/roles/${roleState.id}`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ROLE_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));

        setState({ ...roleState, role: responseRole.role });
      });
    setIsRoleEdit(false);
  };

  //Get org role by Id
  const getOrgRoleData = () => {
    instance
      .get(`/organizations/${userInfo.organizationId}/roles/${id}`)
      .then((response) => {
        dispatch(updateIsLoading(true));
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  //delete org role
  const onRoleDelete = () => {
    instance
      .delete(`/organizations/${userInfo.organizationId}/roles/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ROLE_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          navigate('/roles');
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  return (
    <>
      <div className="rounded-sm p-2">
        <PageHeading label="Role Details" />
        <div
          className={`bg-white flex flex-col justify-between ${colors.primaryText} p-4 rounded-sm`}
        >
          <div className="sm:flex justify-between text-md">
            <div>Role</div>
            <div className=" w-1/2">
              {isUserEdit ? (
                <div>
                  <Input
                    placeholder={'Enter Role'}
                    type={'text'}
                    value={role}
                    name="role"
                    onChange={(event) => {
                      handleChangeText(event);
                    }}
                    error={formError?.role}
                  />
                </div>
              ) : (
                <div className="text-sky-900">
                  {role.length > 10 ? role.substring(0, 25) + '...' : role}
                </div>
              )}
            </div>
            <div>
              <div className="flex justify-end gap-2">
                {isUserEdit ? (
                  <div className="flex space-x-3">
                    <Button
                      label="Update"
                      buttonType="primary"
                      type="button"
                      onClick={() => handleUpdate()}
                      disabled={role === responseRole.role}
                    />
                    <Button
                      label="Cancel"
                      buttonType="danger"
                      type="button"
                      onClick={() => handleUpdateCancel()}
                    />
                  </div>
                ) : (
                  <Button
                    label="Edit"
                    buttonType="primary"
                    type="button"
                    onClick={() => setIsRoleEdit(true)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center pt-8">
        <Button
          label="Delete Role"
          buttonType="danger"
          type="button"
          onClick={() => setIsDeletePopup(true)}
        />
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Role'}
          onConfirm={() => {
            onRoleDelete();
          }}
        />
      </div>
    </>
  );
};

export default RolesDetails;
